/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const FLOPPY_DISK_VIEWBOX = 14;

/**
 * Floppy disk / save (14×14). Color via `currentColor`.
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const FloppyDiskIcon = ({
  size = 14,
  strokeWidth = 1.16667,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${FLOPPY_DISK_VIEWBOX} ${FLOPPY_DISK_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d="M11.0833 12.25H2.91667C2.27277 12.25 1.75 11.7272 1.75 11.0833V2.91667C1.75 2.27277 2.27277 1.75 2.91667 1.75H9.33333L12.25 4.66667V11.0833C12.25 11.7272 11.7272 12.25 11.0833 12.25V12.25"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <rect
      x="4.08301"
      y="7.58337"
      width="5.83333"
      height="4.66667"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      fill="none"
    />
    <path d="M4.08301 1.75V4.66667H8.74967" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

FloppyDiskIcon.propTypes = {
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default FloppyDiskIcon;
